import React, { useContext, useEffect, useState } from 'react';
import StructureView from './StructureView';
import UserContext, { UserProfileContext } from '../../common/utils/getContext';
import { getCurrentUserData } from './initData';
import Skeleton from '../../widgets/plug/Skeleton/Skeleton';
import { officeGridFilterSkeleton } from '../../widgets/plug/Skeleton/components/patterns';
import { getData } from '../../common/utils/router';

const RenderPage = ({ response }) => {
    const { profileData } = useContext(UserProfileContext) || {};
    return (
        <StructureView
            dataStats={response}
            userData={getCurrentUserData(profileData, response)}
            variant={response?.data?.base_stats?.descendants_count < 5000 ? 1 : 2}
        />
    );
};

const Structure = () => {
    const { userToken, lang, display_country } = useContext(UserContext);
    const { loaded } = useContext(UserProfileContext) || {};
    const [initialStatsData, setInitialStatsData] = useState(null);

    useEffect(() => {
        getData(
            !!Number(display_country) ? '/api/v1/user/marketing/country-partner-stats' : '/api/v1/user/marketing/partner-stats',
            userToken,
            lang
        ).then((res) => {
            setInitialStatsData(res);
        });
    }, [userToken, lang, display_country]);

    return (
        <Skeleton
            wait={!!initialStatsData && !!loaded}
            Component={RenderPage}
            componentProps={{
                response: initialStatsData
            }}
            pattern={officeGridFilterSkeleton}
        />
    );
};
export default Structure;
